import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Col, ButtonToolbar, Container } from 'reactstrap';
import { change, Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import renderSelectField from '../../../shared/components/form/Select';
import renderRadioButtonField from '../../../shared/components/form/RadioButton';
import validate from './validate';
import Modal from '../../../shared/components/Modal';
import RemoteResetButton from './RemoteResetButton';
import RemoteSaveButton from './RemoteSaveButton';
import history from '../../../history';

const renderField = ({
    input, placeholder, type, meta: { touched, error },
}) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
        <input {...input} placeholder={placeholder} type={type} />
        {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
);

renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
};


class ThirdPartyForm extends Component {
    constructor() {
        super();
        this.state = {
            nit: '',
            name: '',
            regime: '',
            clientGroup: '',
            country: '',
            department: '',
            address: '',
            email: '',
            webSite: '',
            sgss: '',
            resolution: '',
            days: 0,
            particular: null,
            history: null,
            errors: {},
            toucheds: {},
            openAlert: false,
            color: '',
            departments: [],
            cities: [],
            loadData: false,
        };
    }

    componentDidMount() {
        this.setState({ loadData: true }, () => {
            this.loadDepartment().then((departments) => {
                this.setState({ departments: departments }, () => {

                })
            })
        })
    }

    maskNIT = (valor) => {
        var cadena = "";
        if (valor.match(/^(([0-9]|(-{1})){0,11})$/) && valor.length <= 11) {
            cadena = valor;
        } else if (valor.length > 11) {
            cadena = this.state.nit;
        } else {
            cadena = this.state.nit;
        }

        console.log("cadena:" + cadena);
        return cadena;
    }

    handleNit = (value) => {
        //console.log(value);
        var nit = this.maskNIT(value);
        console.log(value);
        this.setState({ nit: nit }, () => {
            //this.validateData("nit", value);
        });
    }

    handleName = (value) => {
        this.setState({ name: value }, () => {
            this.validateData("name", value);
        });

    }

    handleRegime = (value) => {
        this.setState({ regime: value }, () => {
            this.validateData("regime", value);
        });

    }

    handleClientGroup = (value) => {
        this.setState({ clientGroup: value }, () => {
            this.validateData("clientGroup", value);
        });
    }

    handleCountry = (e) => {
        this.setState({ country: e.value }, () => {
            this.validateData("country", e.value);
        });

    }

    handleDepartment = (e) => {
        this.setState({ department: e, city: {} }, () => {
            const { dispatch } = this.props;
            dispatch(change('third_party_form', 'select_city', ''));
            this.loadCities(e.value).then((cities) => {
                this.setState({ cities: cities });
            });
        });
    }

    handleCity = (e) => {
        this.setState({ city: e });
    }

    handleAddress = (value) => {
        this.setState({ address: value }, () => {
            this.validateData("address", value);
        });
    }

    handleEmail = (value) => {
        this.setState({ email: value }, () => {
            this.validateData("email", value);
        });
    }

    handleWebSite = (value) => {
        this.setState({ webSite: value }, () => {
            this.validateData("website", value);
        });
    }

    handleSGSS = (value) => {
        this.setState({ sgss: value }, () => {
            this.validateData("sgss", value);
        });
    }

    handleResolution = (value) => {
        this.setState({ resolution: value }, () => {
            this.validateData("resolution", value);
        });
    }

    handleDaysDeadLine = (value) => {
        this.setState({ days: value }, () => {
            this.validateData("days", value);
        });
    }

    handleParticular = (value) => {
        this.setState({ particular: value }, () => {
            this.validateData("particular", value);
        });
    }

    handleHistory = (value) => {
        this.setState({ history: value }, () => {
            this.validateData("history", value);
        });
    }

    handleReset = () => {
        console.log(this.state.nit);
        this.setState({
            nit: '',
            name: '',
            regime: '',
            clientGroup: '',
            country: '',
            department: '',
            address: '',
            email: '',
            webSite: '',
            sgss: '',
            resolution: '',
            days: 0,
            particular: null,
            history: null,
            errors: {},
            toucheds: {},
            openAlert: false,
            color: '',
        });
    }

    validateData = (data, value) => {
        var errors = validate({ [data]: value });
        //console.log("error:0 " + JSON.stringify(errors));
        var errorNew = this.state.errors;
        errorNew[data] = errors[data];
        this.setState({ errors: errorNew });
    }

    handleSubmit = async () => {
        var dataVal = {
            nit: this.state.nit,
            name: this.state.name,
            regime: this.state.regime,
            clientGroup: this.state.clientGroup,
            country: this.state.country,
            department: this.state.department,
            address: this.state.address,
            email: this.state.email,
            website: this.state.webSite,
            sgss: this.state.sgss,
            resolution: this.state.resolution,
            days: this.state.days,
            particular: this.state.particular,
            history: this.state.history
        }
        var errors = validate(dataVal);
        this.setState({ errors: errors });
        console.log(JSON.stringify(errors));
        if (Object.entries(errors).length === 0) {
            console.log("Check OK!!");
            var dataSend = {
                nit: this.state.nit,
                nombre: this.state.name,
                regimen: this.state.regime,
                grupodecliente: this.state.clientGroup,
                direccion:
                {
                    id_pais: this.state.country,
                    id_dpto: this.state.department.value,
                    id_ciudad: this.state.city.value,
                    direccion: this.state.address
                },
                correo: this.state.email,
                paginaweb: this.state.webSite,
                codigosgsss: this.state.sgss,
                resolucionss: this.state.resolution,
                diasvencimiento: this.state.days,
                clienteparticular: this.state.particular,
                copiahistoriac: this.state.history
            }

            console.log(dataSend);
            //console.log([this.state.city, this.state.department, this.state.country]);

            fetch(process.env.REACT_APP_PUBLIC_URL + 'tercero/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            }).then(response => {
                return response.json();
            }).then(data => {
                this.setState({ openAlert: true, color: "success", title: "Exitoso!", message: data });
            }).catch((error) => {
                console.error('Error:', error);
                this.setState({ openAlert: true, color: "success", title: "Error!", message: error.message });
            });

            /*var result = await response.json();
            console.log(result);
            this.setState({ openAlert: true, color: "success", title: "Exitoso!", message: result });*/

        }
    }

        loadDepartment = () => {
            return new Promise((resolve, reject) => {
                fetch(process.env.REACT_APP_PUBLIC_URL + 'departamentos/listar', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                    }
                })
                    .then(response => {
                        return response.json();
                    })
                    .then(data => {
                        resolve(data);
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                        resolve(error);
                    });
            })

        }

        loadCities = (depcod) => {
            var data = { id_dpto: depcod };
            return new Promise((resolve, reject) => {
                fetch(process.env.REACT_APP_PUBLIC_URL + 'ciudades/listar', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                    },
                    body: JSON.stringify(data)
                })
                    .then(response => {
                        return response.json();
                    })
                    .then(data => {
                        resolve(data);
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                        resolve(error);
                    });
            })
        }

        departmentsOption = () => {
            if (this.state.departments.length > 0) {
                return this.state.departments.map((department) => {
                    return { value: department.depcod, label: department.depnom, id: department.id }
                });
            }
        }

        citiesOptions = () => {
            var cities = this.state.cities.map((city) => {
                return { value: city.ciucod, label: city.ciunom, id: city.id }
            })
            cities.push({ value: '', label: '', id: 0 });

            return cities;
        }


        render() {
            return (
                <Container className="dashboard">
                    <Col md={12} lg={12}>
                        <Card>
                            <CardBody>
                                <div className="form">
                                    <div class="form__half" style={{ marginRight: 30 }}>
                                        <div className="form__form-group">
                                            <span className="form__form-group-label">NIT</span>
                                            <div className="form__form-group-field">
                                                <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
                                                    <input
                                                        placeholder="123456789-1"
                                                        value={this.state.nit}
                                                        type="text"
                                                        onChange={(e) => this.handleNit(e.target.value)}
                                                    />
                                                    {this.state.errors.nit !== '' && this.state.errors.nit && <span className="form__form-group-error">{this.state.errors.nit}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form__form-group">
                                            <span className="form__form-group-label">Regimen</span>
                                            <div className="form__form-group-field">
                                                <Field
                                                    name="select_regime"
                                                    component={renderSelectField}
                                                    className="form__form-group-input-wrap--error-above"
                                                    value={this.state.regime}
                                                    meta={{ touched: this.state.errors.regime !== '', error: this.state.errors.regime }}
                                                    onChange={(e) => {
                                                        this.handleRegime(e.value);
                                                    }}
                                                    options={[
                                                        { value: 'contributivo', label: 'Regimen contributivo' },
                                                        { value: 'subsidiado', label: 'Regimen subsidiado' },
                                                    ]}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form__half">
                                        <div className="form__form-group">
                                            <span className="form__form-group-label">Nombre</span>
                                            <div className="form__form-group-field">
                                                <Field
                                                    name="name"
                                                    component={renderField}
                                                    type="text"
                                                    placeholder="Nombre"
                                                    value={this.state.name}
                                                    meta={{ touched: this.state.errors.name !== '', error: this.state.errors.name }}
                                                    onChange={(e) => this.handleName(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="form__form-group">
                                            <span className="form__form-group-label">Grupo de cliente</span>
                                            <div className="form__form-group-field">
                                                <Field
                                                    name="select_client_group"
                                                    component={renderSelectField}
                                                    className="form__form-group-input-wrap--error-above"
                                                    value={this.state.clientGroup}
                                                    meta={{ touched: this.state.errors.clientGroup !== '', error: this.state.errors.clientGroup }}
                                                    onChange={(e) => {
                                                        this.handleClientGroup(e.value);
                                                    }}
                                                    options={[
                                                        { value: 'contributivo', label: 'Regimen contributivo' },
                                                        { value: 'subsidiado', label: 'Regimen subsidiado' },
                                                        { value: 'otros', label: 'Otros' },
                                                    ]}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form__half" style={{ marginRight: 30 }}>
                                        <div className="form__form-group">
                                            <span className="form__form-group-label">País</span>
                                            <div className="form__form-group-field">
                                                <Field
                                                    name="select_country"
                                                    component={renderSelectField}
                                                    className="form__form-group-input-wrap--error-above"
                                                    value={this.state.country}
                                                    meta={{ touched: this.state.errors.country !== '', error: this.state.errors.country }}
                                                    onChange={(e) => {
                                                        this.handleCountry(e);
                                                    }}
                                                    options={[
                                                        { value: '00038', label: 'COLOMBIA', id: 38 },
                                                    ]}
                                                />
                                            </div>
                                        </div>
                                        <div className="form__form-group">
                                            <span className="form__form-group-label">Ciudad</span>
                                            <div className="form__form-group-field">
                                                <Field
                                                    name="select_city"
                                                    component={renderSelectField}
                                                    className="form__form-group-input-wrap--error-above"
                                                    value={this.state.city}
                                                    meta={{ touched: this.state.errors.city !== '', error: this.state.errors.city }}
                                                    onChange={(e) => {
                                                        this.handleCity(e);
                                                    }}
                                                    options={this.citiesOptions()}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form__half">
                                        <div className="form__form-group">
                                            <span className="form__form-group-label">Departamento</span>
                                            <div className="form__form-group-field">
                                                <Field
                                                    name="select_department"
                                                    component={renderSelectField}
                                                    className="form__form-group-input-wrap--error-above"
                                                    value={this.state.department}
                                                    meta={{ touched: this.state.errors.department !== '', error: this.state.errors.department }}
                                                    onChange={(e) => {
                                                        this.handleDepartment(e);
                                                    }}
                                                    options={this.departmentsOption()}
                                                />
                                            </div>
                                        </div>
                                        <div className="form__form-group">
                                            <span className="form__form-group-label">Dirección</span>
                                            <div className="form__form-group-field">
                                                <Field
                                                    name="address"
                                                    component={renderField}
                                                    type="text"
                                                    placeholder="Dirección"
                                                    value={this.state.address}
                                                    meta={{ touched: this.state.errors.address !== '', error: this.state.errors.address }}
                                                    onChange={(e) => this.handleAddress(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form__half" style={{ marginRight: 30 }}>
                                        <div className="form__form-group">
                                            <span className="form__form-group-label">E-mail</span>
                                            <div className="form__form-group-field">
                                                <Field
                                                    name="email"
                                                    component={renderField}
                                                    type="email"
                                                    placeholder="example@mail.com"
                                                    value={this.state.email}
                                                    meta={{ touched: this.state.errors.email !== '', error: this.state.errors.email }}
                                                    onChange={(e) => this.handleEmail(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form__half">
                                        <div className="form__form-group">
                                            <span className="form__form-group-label">Pagina web</span>
                                            <div className="form__form-group-field">
                                                <Field
                                                    name="website"
                                                    component={renderField}
                                                    type="text"
                                                    placeholder="https://www.example.domain"
                                                    value={this.state.webSite}
                                                    meta={{ touched: this.state.errors.website !== '', error: this.state.errors.website }}
                                                    onChange={(e) => this.handleWebSite(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form__half" style={{ marginRight: 30 }}>
                                        <div className="form__form-group">
                                            <span className="form__form-group-label">Resolución supersalud</span>
                                            <div className="form__form-group-field">
                                                <Field
                                                    name="resolution"
                                                    component={renderField}
                                                    type="number"
                                                    placeholder="Código"
                                                    value={this.state.resolution}
                                                    meta={{ touched: this.state.errors.resolution !== '', error: this.state.errors.resolution }}
                                                    onChange={(e) => this.handleResolution(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="form__form-group">
                                            <span className="form__form-group-label">Codigo SGSSS</span>
                                            <div className="form__form-group-field">
                                                <Field
                                                    name="sgss"
                                                    component={renderField}
                                                    type="number"
                                                    placeholder="Código"
                                                    value={this.state.sgss}
                                                    meta={{ touched: this.state.errors.sgss !== '', error: this.state.errors.sgss }}
                                                    onChange={(e) => this.handleSGSS(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div class="form__half">

                                        <div className="form__form-group">
                                            <span className="form__form-group-label">Días de vencimiento</span>
                                            <div className="form__form-group-field">
                                                <Field
                                                    name="days_deadline"
                                                    component={renderField}
                                                    type="number"
                                                    placeholder="numero de dias de vencimiento"
                                                    value={this.state.days}
                                                    meta={{ touched: this.state.errors.days !== '', error: this.state.errors.days }}
                                                    onChange={(e) => this.handleDaysDeadLine(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">Cliente particular</span>
                                        <div className="form__form-group-field">
                                            <Field
                                                name="particular"
                                                component={renderRadioButtonField}
                                                label="Si"
                                                radioValue={'Si'}
                                                value={this.state.particular}
                                                onChange={(e) => {
                                                    this.handleParticular(e)
                                                }}
                                            />
                                            <Field
                                                name="particular"
                                                component={renderRadioButtonField}
                                                label="No"
                                                radioValue={'No'}
                                                value={this.state.particular}
                                                onChange={(e) => {
                                                    this.handleParticular(e)
                                                }}
                                            />
                                            {this.state.errors.particular !== '' && this.state.errors.particular && <span className="form__form-group-error">{this.state.errors.particular}</span>}
                                        </div>
                                    </div>
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">Copia de historial Clinico</span>
                                        <div className="form__form-group-field">
                                            <Field
                                                name="history"
                                                component={renderRadioButtonField}
                                                label="Si"
                                                radioValue={"Si"}
                                                value={this.state.history}
                                                onChange={(e) => {
                                                    this.handleHistory(e)
                                                }}
                                            />
                                            <Field
                                                name="history"
                                                component={renderRadioButtonField}
                                                label="No"
                                                radioValue={"No"}
                                                value={this.state.history}
                                                onChange={(e) => {
                                                    this.handleHistory(e)
                                                }}
                                            />
                                            {this.state.errors.history !== '' && this.state.errors.history && <span className="form__form-group-error">{this.state.errors.history}</span>}
                                        </div>
                                    </div> */}
                                    <ButtonToolbar className="form__button-toolbar">
                                        <RemoteSaveButton submit={this.handleSubmit} />
                                        <RemoteResetButton resetData={this.handleReset} />
                                    </ButtonToolbar>
                                    {this.state.openAlert ?
                                        <Modal
                                            color={this.state.color}
                                            title={this.state.title}
                                            message={this.state.message}
                                            modal={this.state.openAlert}
                                            toggle={() => { this.setState({ openAlert: !this.state.openAlert }) }}
                                            onOk={() => {
                                                history.push({
                                                    pathname: process.env.PUBLIC_URL +'/config/third-parties',
                                                })
                                            }}
                                        /> : null}
                                </div>

                            </CardBody>
                        </Card>
                    </Col>
                </Container>)
        }
    }

export default reduxForm({
        form: 'third_party_form', // a unique identifier for this form
    })(withTranslation('common')(ThirdPartyForm));
